<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul de Campo</mat-label>

                                <mat-select multiple disableCenteringOption formControlName="Fx_azul_campo"
                                    id="ddFx_azul_campo" (selectionChange)="getFormFagData($event)">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxAzulCampo($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzulCampo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>

                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Umidade</mat-label>
                                <input matInput id="txtFxAzulUmidade" #txtFxAzulUmidade maxlength="3" readonly
                                    formControlName="Fx_azul_umidade" (blur)="getFormFagData()" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFxAzulUmidade.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_umidade)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Temperatura</mat-label>
                                <input matInput id="txtFxAzulTemperatura" #txtFxAzulTemperatura maxlength="3" readonly
                                    formControlName="Fx_azul_temperatura" (blur)="getFormFagData()"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFxAzulTemperatura.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_temperatura)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Tempo (não monitorado)</mat-label>
                                <input matInput id="txtfxAzulMonit" #txtAzulMonit maxlength="3" readonly
                                    formControlName="Fx_azul_tempo_nmonitorado" (blur)="getFormFagData()"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtAzulMonit.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_tempo_nmonitorado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por transbordo</mat-label>
                                <input matInput id="txtfxAzulTransbordo" #txtfxAzulTransbordo maxlength="3" readonly
                                    formControlName="Fx_azul_transbordo" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtfxAzulTransbordo.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_transbordo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Geral</mat-label>
                                <input matInput id="txtfxAzulGeral" #txtfxAzulGeral maxlength="3" readonly
                                    formControlName="Fx_azul_geral" (blur)="getFormFagData()" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtfxAzulGeral.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_geral)}}</mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa de Qualidade Física</mat-label>
                                <mat-select formControlName="Faixa_qualidade_fisica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxQualFis($event.target.value)">

                                    <mat-option *ngFor="let item of listFxQualFis" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_qualidade_fisica)}}
                                </mat-error>
                            </mat-form-field>
                        </div>




                    </div>

                    <div class="row pt-3">


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                    formControlName="criado_por" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Respónsavel pelo lançamento</mat-label>
                                <input matInput id="txtRespLancamento" #txtRespLancamento maxlength="40"
                                    formControlName="Resp_lancamento" (blur)="getFormFagData()" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtRespLancamento.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Resp_lancamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Desvio e Observações</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="Observacao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Semana da Colheita (Sequência)</mat-label>
                                <input matInput id="txtSemColheitaSeq" #txtSemColheitaSeq maxlength="10" readonly
                                    formControlName="Sem_colheita_sequencia" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSemColheitaSeq.value.length}} / 9</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Sem_colheita_sequencia)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Semana da Colheita Data</mat-label>
                                <input matInput id="txtSemColheitaDate" #txtSemColheitaDate maxlength="10" readonly
                                    formControlName="Sem_colheita_data" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSemColheitaDate.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Sem_colheita_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!--<div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Última Carga</mat-label>
                                <mat-select formControlName="Ultima_carga" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterUltimaCarga($event.target.value)">
                                    <mat-option *ngFor="let item of listUltimaCarga" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                 <input type="text" placeholder="Última Carga" matInput [matAutocomplete]="auto"
                                    formControlName="Ultima_carga" id="txtCarga" maxlength="3" #txtCarga>
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredUltimaCargaOptions | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtCarga.value.length}} / 3</mat-hint>
                            </mat-form-field>
                        </div> -->
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Toneladas/Horas/Lanes</mat-label>
                                <input matInput id="txtLanes" #txtLanes maxlength="20" readonly
                                    formControlName="Tonhrlanes" class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 3 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtLanes.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tonhrlanes)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                                    formControlName="criado_por" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Respónsavel pelo lançamento</mat-label>
                                <input matInput id="txtRespLancamento" #txtRespLancamento maxlength="40"
                                    formControlName="Resp_lancamento" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtRespLancamento.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Resp_lancamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Houve desvio de documentação?</mat-label>
                                <mat-select formControlName="houve_desvio_documentacao" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxQualFis($event.target.value)">

                                    <mat-option *ngFor="let item of listFxQualFis" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.houve_desvio_documentacao)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Semana da Colheita (Sequência)</mat-label>
                                <input matInput id="txtSemColheitaSeq" #txtSemColheitaSeq maxlength="10" readonly
                                    formControlName="Sem_colheita_sequencia" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSemColheitaSeq.value.length}} / 9</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Sem_colheita_sequencia)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Semana da Colheita Data</mat-label>
                                <input matInput id="txtSemColheitaDate" #txtSemColheitaDate maxlength="10" readonly
                                    formControlName="Sem_colheita_data" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtSemColheitaDate.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Sem_colheita_data)}}</mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observações</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="Observacao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!--<div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Última Carga</mat-label>
                                <mat-select formControlName="Ultima_carga" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterUltimaCarga($event.target.value)">
                                    <mat-option *ngFor="let item of listUltimaCarga" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                                 <input type="text" placeholder="Última Carga" matInput [matAutocomplete]="auto"
                                    formControlName="Ultima_carga" id="txtCarga" maxlength="3" #txtCarga>
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredUltimaCargaOptions | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtCarga.value.length}} / 3</mat-hint>
                            </mat-form-field>
                        </div> -->

                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>